import React, { useState, useEffect } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import {
  SimpleGrid,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  FormLabel,
} from "@chakra-ui/react";
import { CustomButton } from "../../../../../../components/CustomButton";
import { FocusError } from "../../../../../../components/FocusError";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { hasFormChanged } from "../../../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../../../Context/MessageContextProvider";
import ChangeRadio from "../../../../../../components/ChangeRadio";
import CriancaService from "../../../../../../../main/services/CriancaService";
import { IrmaoTable } from "../../../../ReferenciaFamiliar/Irmaos/Table";

const schema = Yup.object().shape({
  extincaoPoderFamilia: Yup.string().required("Este campo é obrigatório!"),
  idProcessoProcedimento: Yup.number().required("Este campo é obrigatório!"),
});

export const EntregaVoluntariaModal = ({
  isOpen,
  onOpen,
  onClose,
  idCrianca,
  fetchEntregaVoluntaria,
  columnsEntregaCadastrar,
  data,
  dataVoluntaria,
  alerta,
  buttonText,
}) => {
  const {
    cadastrarProcessosProcedimentos,
    setCadastrarProcessosProcedimentos,
  } = useAppContext();

  const [initialValues, setInitialValues] = useState({
    idProcessoProcedimento: "",
    extincaoPoderFamilia: "",
  });

  useEffect(() => {
    if (dataVoluntaria) {
      setInitialValues({
        idProcessoProcedimento: dataVoluntaria[0]?.idProcesso
          ? dataVoluntaria[0]?.idProcesso.toString()
          : "",
        extincaoPoderFamilia: dataVoluntaria[0]?.extincaoPoderFamilia,
      });
    }
  }, [dataVoluntaria]);

  const [, setTempSelected] = useState();
  const [, setTreatedData] = useState();

  const backAlert = () => {
    if (cadastrarProcessosProcedimentos) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setCadastrarProcessosProcedimentos(false);
        }
      });
    } else {
      onClose();
    }
  };

  const addEntregaVoluntaria = async (
    id,
    valuesToSend,
    idEntregaVoluntaria
  ) => {
    try {
      if (buttonText === "Cadastrar") {
        await CriancaService.cadastrarEntregaVoluntaria(id, valuesToSend);
        Swal.fire({
          title: "Sucesso!",
          text: "Registro cadastrado com sucesso!",
          icon: "success",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#169499",
        }).then((result) => {});
      } else {
        await CriancaService.editarEntregaVoluntaria(
          id,
          valuesToSend,
          idEntregaVoluntaria
        );
        Swal.fire({
          title: "Sucesso!",
          text: "Registro atualizado com sucesso!",
          icon: "success",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#169499",
        }).then((result) => {});
      }
      onClose();
      fetchEntregaVoluntaria();
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error?.response?.data?.message
          ? error?.response?.data?.message
          : "",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (data) {
      setTreatedData(data);
    } else {
      setTreatedData(null);
    }
    setTempSelected(null);
  }, [data]);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { extincaoPoderFamilia, idProcessoProcedimento } = values;

      const valuesToSend = {
        extincaoPoderFamilia: extincaoPoderFamilia,
        idProcessoProcedimento: idProcessoProcedimento
          ? Number(idProcessoProcedimento)
          : null,
      };
      addEntregaVoluntaria(
        Number(idCrianca),
        valuesToSend,
        dataVoluntaria[0]?.id
      );

      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "100%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {`${buttonText} Entrega Voluntária`.toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <Form style={{ width: "100%" }}>
                  {setCadastrarProcessosProcedimentos(
                    hasFormChanged(initialValues, props.values)
                  )}

                  <FocusError />

                  <Grid templateColumns="repeat(3, 1fr) 1fr" gap={2}>
                    <GridItem colSpan={7}>
                      <ChangeRadio
                        setFieldValue={props.setFieldValue}
                        values={props.values}
                        fieldName={"extincaoPoderFamilia"}
                        label={"Houve Extinção do Poder Familiar?*"}
                      />
                    </GridItem>

                    {!alerta && (
                      <GridItem colSpan={4}>
                        <FormLabel
                          py="2"
                          m={0}
                          mt={4}
                          px={6}
                          color={"gray.600"}
                          bgColor={"#DDEBEA"}
                          width="full"
                          fontWeight="700"
                          fontSize="14px"
                          lineHeight="19.6px"
                          htmlFor={"irmaos"}
                        >
                          {"Selecione o Processo/Procedimento correspondente*"}
                        </FormLabel>
                        <IrmaoTable
                          disableHeaderOptionsOpcoes={true}
                          mt={"0px"}
                          props={props}
                          columns={columnsEntregaCadastrar}
                          data={data}
                          filiacoes={data}
                          entidade="entrega"
                          entregaCadastrar={true}
                          entrega={true}
                          idCrianca={idCrianca}
                        />
                      </GridItem>
                    )}
                  </Grid>

                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={2}
                      spacing="15px"
                      w={{ base: "100%", lg: "40%" }}
                    >
                      <CustomButton onClick={backAlert} label="Cancelar" />
                      <CustomButton
                        type="submit"
                        translate="no"
                        isLoading={props.isSubmitting}
                        label="Salvar"
                      />
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
